import { setupLink } from './setup-link';

export const linkAPI = () => ({
  setup: setupLink,
  getCursor: () => 'crosshair',
});
